import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { MainLayuotComponent } from './layout/main-layuot/main-layuot.component';
import {MatIconModule} from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AlertComponent } from 'app/components/common/alert/alert.component';
import {MatTooltipModule} from '@angular/material/tooltip';

const MODULES = [
  MatCardModule,
  FormsModule,
  ReactiveFormsModule,
  MatInputModule,
  TranslateModule,
  MatButtonModule,
  MatIconModule,
  RouterModule,
  MatTooltipModule
]

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MainLayuotComponent,
    AlertComponent
  ],
  imports: [
    CommonModule,
    ...MODULES
  ],
  exports: [...MODULES,
    MainLayuotComponent,
    AlertComponent]
})
export class ThemeModule { }
